// 업체별 사실·가격·기간을 단정하지 않고, 작성해야 할 정보를 알려주는 초기 안내 문구다.
// 대괄호 항목은 실제 운영 정보로 반드시 바꿔야 한다.
export const EXCLUSIVE_BENEFIT_DEFAULTS = {
  package: "단독 패키지를 제공한다면 아래 내용을 채워주세요.\n포함 상품/서비스: [구성 1], [구성 2]\n기존 상품과 다른 점: [구성·이용조건을 입력해주세요]\n제공하지 않으면 이 항목의 체크를 해제해주세요.",
  discount: "단독 할인이 있다면 아래 내용을 채워주세요.\n대상 상품/서비스: [상품명]\n기존 조건: [정상가 또는 기존 조건]\n단독 조건: [할인가 또는 할인 방식]\n적용 기간·수량 제한: [있는 경우 입력해주세요]\n제공하지 않으면 이 항목의 체크를 해제해주세요.",
  gift: "단독 혜택이 있다면 아래 내용을 채워주세요.\n혜택 내용: [증정품 또는 추가 서비스]\n제공 시점: [방문 시 / 이용 후 / 결제 시 등]\n제공 조건·제한: [있는 경우 입력해주세요]\n제공하지 않으면 이 항목의 체크를 해제해주세요.",
} as const;

export const EXCLUSIVE_BENEFIT_DEFAULT_VALUE = [
  "[단독 패키지 구성]",
  EXCLUSIVE_BENEFIT_DEFAULTS.package,
  "[단독 할인]",
  EXCLUSIVE_BENEFIT_DEFAULTS.discount,
  "[단독 혜택]",
  EXCLUSIVE_BENEFIT_DEFAULTS.gift,
].join("\n\n");

export const GENERAL_GUIDANCE_DEFAULTS = {
  content: {
    catchphrase: "[대표 상품/서비스]를 [핵심 장점]과 함께 경험해 보세요",
    primarySellingPoint: "[대표 상품/서비스]로 고객이 얻을 수 있는 [기대 경험 또는 변화]를 적어주세요.\n이를 뒷받침하는 [경력·후기·운영 사례·확인 가능한 수치]를 함께 적어주세요.\n외국인 고객에게 특히 편리한 [언어·위치·예약·결제] 정보를 적어주세요.",
    recommendationReason: "1. [어떤 고객에게 추천하는지]\n2. [고객이 이곳에서 얻는 경험·결과]\n3. [경력·후기·운영 사례 등 이를 뒷받침하는 근거]",
    creatripExclusiveBenefit: EXCLUSIVE_BENEFIT_DEFAULT_VALUE,
    clinicStrengths: "• [대표자/전문가의 경력]\n• [대표 상품·서비스의 강점]\n• [확인 가능한 수치·인증·후기]",
    serviceEnvironment: "• [가능 언어와 응대 방식]\n• [대중교통·주차 등 위치 안내]\n• [결제·짐 보관·와이파이 등 방문 편의]",
  },
  policy: {
    otherPrecautions: "• 예약 시간보다 [몇 분] 전에 도착해주세요.\n• 방문 전 [준비물/사전 확인사항]을 확인해주세요.\n• [변경·취소·노쇼] 기준을 적어주세요.\n• 서비스 후 [관리·주의사항]을 안내해주세요.",
  },
  consultationProduct: {
    detailDescription: "1. 예약확인증을 제시하고 [희망 서비스]를 알려주세요.\n2. 상담을 통해 [고민·희망 사항]을 확인합니다.\n3. 상담 결과에 따라 적합한 상품/서비스와 비용을 안내합니다.\n4. 고객이 결정한 뒤 진행합니다.",
  },
} as const;
